import React, { useEffect, useState } from 'react';
import { useCart } from '../../../hooks/useCart';
import Money from '../../Money';

type MiniCartAddGiftWrapProps = {
  children: React.ReactNode;
  excludedSkus: string;
  giftWrapProduct: {
    id: number;
    price: number;
  };
};

export function MiniCartAddGiftWrap({
  children,
  giftWrapProduct,
  excludedSkus = '',
}: MiniCartAddGiftWrapProps): JSX.Element | null {
  const { cart, addToCart } = useCart();

  const [isGiftWrapAdded, setIsGiftWrapAdded] = useState(false);

  useEffect(() => {
    const giftWrapItem = cart.items.find(
      (item: any) => item.id === giftWrapProduct.id
    );
    setIsGiftWrapAdded(!!giftWrapItem);
  }, [cart, giftWrapProduct.id]);

  const excludedSkuArray = excludedSkus
    .split(',')
    .map((sku) => sku.trim())
    .filter(Boolean);

  const hasExcludedSku =
    excludedSkuArray.length > 0 &&
    cart.items.some((item: any) => {
      const sku = item.sku || item.product?.sku || item.variant?.sku || '';
      return excludedSkuArray.includes(sku);
    });

  if (hasExcludedSku || isGiftWrapAdded) {
    return null;
  }

  function addGiftWrapProductToCart() {
    addToCart([{ id: giftWrapProduct.id, quantity: 1 }], false);
  }

  return (
    <button
      onClick={addGiftWrapProductToCart}
      className="minicart-add-gift-wrap"
    >
      <i className="fas fa-gift"></i>
      <div className="minicart-add-gift-wrap__text">
        {children} <Money amount={giftWrapProduct.price} />
      </div>
    </button>
  );
}
